import { Component, OnInit } from '@angular/core';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { Address, AddressArt } from 'src/app/_interfaces/address';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { VCard } from 'src/app/_interfaces/VCard';
import { AuthService } from 'src/app/_provider/auth.service';
import { CrmService } from 'src/app/_provider/crm.service';
import { FeedbackService, MsgType } from 'src/app/_provider/feedback.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { SaveService } from 'src/app/_provider/save.service';
import { PopoverListItem, PopoverPage } from 'src/app/_template/popover/popover.page';
import * as vCardParser from "vcard-parser"

@Component({
  selector: 'app-crm-edit',
  templateUrl: './crm-edit.page.html',
  styleUrls: ['./crm-edit.page.scss'],
})
export class CrmEditPage implements OnInit {

  public isNew: boolean = true

  public crm: Address = {
    number: "",
    description: "",
    salutation: "",
    companyOne: "",
    firstName: "",
    lastName: "",
    street: "",
    plz: "",
    town: "",
    country: "",
    telefone: "",
    telefoneTwo: "",
    mobile: "",
    telefax: "",
    email: "",
    website: "",
    addressArtId: 0,
    addressIdentifierName: "",
  }

  public get selectedAddressArt(): AddressArt{
    return this.crmSrv.addressArts.find(aa => aa.id === this.crm.addressArtId);
  }

  constructor(
    private modalCtrl: ModalController,
    private feedback: FeedbackService,
    private authSrv: AuthService,
    public platform: Platform,
    private navCtrl: NavController,
    private crmSrv: CrmService,
    public generalSrv: GeneralService,
    private saveSrv: SaveService.CRM
  ) { }

  async ngOnInit() {
    await Promise.all([this.crmSrv.loadAddressArts(), this.crmSrv.loadAddressIdentifiers()])
    this.crm.addressArtId = this.crmSrv.addressArts.find(aa => aa.show)?.id || 0
  }

  public async back(){
    await this.modalCtrl.dismiss()
  }

  public async save(){

    if(this.authSrv.isDemoMode)
      return await this.feedback.showMsg(MsgType.Info, "In der Demo-Version kann leider keine neue Adresse angelegt oder bearbeitet werden. Sie können jedoch in den existierenden Adressen alles ausprobieren.🥸")
    

    if(!this.crm.companyOne) return await this.feedback.showError("Bitte geben Sie einen Firmennamen an.")

    if(this.crm.town) this.crm.description = `${this.crm.companyOne} - ${this.crm.town}`
    else this.crm.description = this.crm.companyOne

    await this.feedback.updateLoading("Speichern...")
    let result: HttpFunctionResult<Address>
    if(this.isNew) result = await this.saveSrv.createAddress(this.crm)
    else result = await this.saveSrv.updateAddress(this.crm)
    await this.feedback.hideLoading()
    if(!result.success) return 
    await this.modalCtrl.dismiss(result.data)

  }

  public async openQrCode(){
    const vcardResponse: HttpFunctionResult<string> = await this.feedback.getQRCodeData()
    if(!vcardResponse.success) return
    const parsedData: VCard = vCardParser.parse(vcardResponse.data) as VCard
    try {
      this.crm.companyOne = this.getVcardValue(parsedData, "org") 
      this.crm.salutation = this.getVcardValue(parsedData, "title") 
      this.crm.firstName =  this.getVcardValueByArray(parsedData, "n", 1) 
      this.crm.lastName = this.getVcardValueByArray(parsedData, "n", 0) 
      this.crm.telefone = this.getVcardValue(parsedData, "tel") 
      this.crm.telefoneTwo = this.getVcardValue(parsedData, "tel", 1) 
      this.crm.email = this.getVcardValue(parsedData, "email") 
      this.crm.website = this.getVcardValue(parsedData, "url") 
      this.crm.street = this.getVcardValueByArray(parsedData, "adr", 2) 
      this.crm.town = this.getVcardValueByArray(parsedData, "adr", 3)
      this.crm.plz = this.getVcardValueByArray(parsedData, "adr", 5)
      this.crm.country = this.getVcardValueByArray(parsedData, "adr", 6) 
    } catch (error) {
      alert(error)
    }
  }

  private getVcardValue(vcardResponse: VCard, name: string, position: number = 0): string{
    if( vcardResponse?.[name] == undefined) return ""
    return vcardResponse?.[name][position]?.value || ""
  }

  private getVcardValueByArray(vcardResponse: VCard, name: string, position: number = 0): string{
    if( vcardResponse?.[name] == undefined) return ""
    if( vcardResponse?.[name][0]?.value[position] == undefined) return ""
    return vcardResponse?.[name][0]?.value[position] || ""
  }

  public async selectArt(event: any){

    const list: PopoverListItem[] = this.crmSrv.addressArts.filter(aa => aa.show)
    .map(aa => ({
      id: aa.id,
      description: aa.description,
      icon: aa.icon,
    }))

    await this.feedback.openPopover(PopoverPage, event, {list}, (result: HttpFunctionResult<PopoverListItem>)=>{
      if(!result.success) return
      this.crm.addressArtId = result.data.id

    })
  }

  public async selectIdentifier(event: any){
    const list: PopoverListItem[] = this.crmSrv.addressIdentifiers

    const result: HttpFunctionResult<PopoverListItem> = await this.feedback.showPopover({
      component: PopoverPage,
      event: event,
      componentProps: {list},
    })

    if(result.success) this.crm.addressIdentifierName = result.data.description
    

  }


  

}
